import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Alert } from "@mui/material";
import { SEOForm, ComponentHeader } from "components";
import {
  getMetaDetailsByPathname,
  createMetaDetails,
  updateMetaDetails,
} from "actions";
import { clearError, clearMetaDetails } from "features/metaDetailsSlice";
import { META_DETAILS_PATHNAMES } from "constants/general";
import { ADMIN_TEXTS } from "constants/adminTexts";
import "./PrivacyPolicy.scss";

const T = ADMIN_TEXTS.privacyPolicy;

const metaDetailsPathname = META_DETAILS_PATHNAMES.privacyPolicy;
const imageBase = process.env.REACT_APP_API_IMAGE_URL;

export const PrivacyPolicyMetaDetails = () => {
  const dispatch = useDispatch();
  const { metaDetails, loading, updateLoading, error } = useSelector(
    (state) => state.metaDetails,
  );

  const getInitialValues = () => {
    if (!metaDetails) return {};
    return {
      ...metaDetails,
      ogImage: metaDetails.ogImage
        ? `${imageBase}${metaDetails.ogImage.path}`
        : "",
    };
  };

  const handleSubmit = (values) => {
    const formData = new FormData();

    const { ogImage, ...rest } = values;
    for (const [field, value] of Object.entries(rest)) {
      formData.append(field, value);
    }

    if (ogImage instanceof File) {
      formData.append("ogImage", ogImage);
    }

    if (!metaDetails) {
      formData.append("pagePathname", metaDetailsPathname);
      dispatch(createMetaDetails(formData));
    } else {
      dispatch(
        updateMetaDetails({ pathname: metaDetailsPathname, data: formData }),
      );
    }
  };

  useEffect(() => {
    dispatch(getMetaDetailsByPathname(metaDetailsPathname));
    return () => {
      dispatch(clearError());
      dispatch(clearMetaDetails());
    };
  }, [dispatch]);

  return (
    <Box className="privacy-policy-meta-details">
      <ComponentHeader title={T.metaDetailsPageTitle} />
      {error && (
        <Alert
          severity="error"
          className="privacy-policy-meta-details__alert"
          onClose={() => dispatch(clearError())}
        >
          {typeof error === "string" ? error : T.genericError}
        </Alert>
      )}
      <SEOForm
        onSubmit={handleSubmit}
        initialValues={getInitialValues()}
        loading={loading || updateLoading}
      />
    </Box>
  );
};
